var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWindowsAppDarkIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Windows_-_Color",
    "data-name": "Windows - Color",
    transform: "translate(-724 -599)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Windows_logo_-_2021",
    d: "M0,0H6.637V6.634H0ZM7.363,0H14V6.634H7.363ZM0,7.363H6.637V14H0Zm7.363,0H14V14H7.363",
    transform: "translate(724 599)",
    fill: "#0078d4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWindowsAppDarkIcon);
export default __webpack_public_path__ + "static/media/windows-app-dark-icon.e0c690a259f4fe21d3647c1f6de5c43a.svg";
export { ForwardRef as ReactComponent };